import PropTypes from 'prop-types';
import React from 'react';

import { Info } from '@bibliocommons/base-icons';
import { libraryShape } from '@bibliocommons/bc-prop-types';
import { FormattedHTMLMessage } from '@bibliocommons/react-intl';

import './CommunityDisclaimer.scss';

export default function CommunityDisclaimer({ type, currentLibrary }) {
  return (
    <div className="cp-ugc-disclaimer">
      <span className="message-icon">
        <Info />
      </span>
      <div className="message">
        <FormattedHTMLMessage
          id="ugc_disclaimer_message"
          values={{ ugcType: type, libraryName: currentLibrary?.get('longName') }}
        />
      </div>
    </div>
  );
}

CommunityDisclaimer.propTypes = {
  currentLibrary: libraryShape.isRequired,
  type: PropTypes.string
};
